import type { ColumnDef, PieMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn } from '../shared/pivot.js';

export interface PieResult {
  labels: string[];
  values: number[];
}

/**
 * Project rows into a labels/values slice list, aggregating rows that share
 * a label by summing their values. Output preserves first-seen (insertion)
 * order — matches the axis-order rule for `text` columns (target #9 corollary).
 *
 * Grafana's piechart panel does the same: a query that returns 9 rows across
 * 3 distinct categories renders 3 slices, not 9.
 */
export function prepPieSeries(
  rows: Record<string, unknown>[],
  _columnDefs: ColumnDef[],
  mapping: PieMapping
): PieResult {
  const tableData = rowsToColumnar(rows);
  const labelsCol = getColumn<string>(tableData, mapping.labels);
  const valuesCol = getColumn<number>(tableData, mapping.values);

  const grouped = new Map<string, number>();
  for (let i = 0; i < labelsCol.length; i++) {
    const key = String(labelsCol[i]);
    const value = Number(valuesCol[i]) || 0;
    grouped.set(key, (grouped.get(key) ?? 0) + value);
  }

  return {
    labels: [...grouped.keys()],
    values: [...grouped.values()],
  };
}
